import * as React from "react";
import bodiZahiral from "../../assets/bodi_zahiral.png";

const headingStyle = { fontFamily: '"Times-Now-Semi-Light", Georgia, serif' };
const bodyStyle = { fontFamily: "Roboto, sans-serif" };

function AboutUs() {
  return (
    <section className="w-full bg-[#fff] mt-14 md:mt-20 pb-14 md:pb-20">
      <div className="max-w-[1500px] mx-auto px-0 md:px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 mt-6 md:mt-10 lg:mt-14">
          <div className="bg-[#fff] px-6 md:px-14 py-10 md:py-16 lg:py-20 flex items-center">
            <div className="max-w-[530px] mx-auto text-center">
              <h2 className="text-[24px] md:text-[30px] text-[#1f1a16] mb-6" style={headingStyle}>
                Community
              </h2>
              <p className="text-[13px] md:text-[14px] leading-6 text-[#5f574c] font-light" style={bodyStyle}>
                Lorem ipsum dolor sit amet consectetur. Ut fermentum dolor nec risus ut ipsum magna. Odio non dictumst
                curabitur neque fermentum praesent leo sit venenatis. Consectetur et mauris integer at ullamcorper
                suspendisse ullamcorper euismod dui. Maecenas mattis scelerisque eget nibh non laoreet euismod id sed.
                Iaculis sit viverra at enim. Dui fringilla ac augue turpis cursus duis. Sed orci quis tortor imperdiet
                dignissim. Sodales ipsum ipsum rhoncus turpis vivamus diam faucibus interdum. Nunc quam in vitae risus
                neque diam massa egestas eu. Dolor lectus porttitor diam mi magna. Eu quam sed neque feugiat. Faucibus
                eleifend suspendisse porta etiam porttitor mauris. Cras.
              </p>
            </div>
          </div>
          <div className="w-full aspect-[4/5]">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/b5dcf6fe1b98f09c8c92efddefd21a3f4b63b89aaf6d85874096b9de34aa9917?apiKey=9804d3a088fa478e8672485264720a14&"
              alt="About Bodios"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-full aspect-[4/5]">
            <img
              src={bodiZahiral}
              alt="People sitting under a tree"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="bg-[#fff] px-6 md:px-14 py-10 md:py-16 lg:py-20 flex items-center">
            <div className="max-w-[530px] mx-auto">
              <h3 className="text-[22px] md:text-[28px] text-[#1f1a16] mb-6 text-center md:text-left" style={headingStyle}>
               Our founder
              </h3>
              <p className="text-[13px] md:text-[14px] leading-6 text-[#5f574c] font-light" style={bodyStyle}>
                Inspired by the extraordinary qualities of yak down—its inherent warmth, luxury, and softness—J. Ulziibodijav founded BODIOS to bring this unique material to life. With a passion for innovation, he devoted himself to refining yak down’s natural properties, crafting designs that honor both quality and nature’s elegance. By blending tradition with modern techniques, BODIOS has created a collection of yak down garments that are cherished both locally and internationally by those who appreciate unparalleled comfort, quality, and sustainability.
              </p>
            </div>
          </div>

          <div className="bg-[#fff] px-6 md:px-14 py-10 md:py-16 lg:py-20 flex items-center">
            <div className="max-w-[530px] mx-auto">
              <h3 className="text-[22px] md:text-[28px] text-[#1f1a16] mb-6 text-center md:text-left" style={headingStyle}>
                Philosophy
              </h3>
              <p className="text-[13px] md:text-[14px] leading-6 text-[#5f574c] font-light" style={bodyStyle}>
                BODIOS crafts products from yak down, offering exceptional warmth, comfort, and environmental sustainability. Committed to ethical business principles that support herders, we strive to bring people closer to nature.
              </p>
            </div>
          </div>

          <div className="w-full aspect-[4/5]">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/298048f44cb87f8a912c8acdf1919739c268f331054c18a3a9d5fa2ee36ac044?apiKey=9804d3a088fa478e8672485264720a14&"
              alt="Brown sheep portrait"
              className="w-full h-full object-cover"
            />
          </div>

        </div>
      </div>
    </section>
  );
}

export default AboutUs;